var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g2, _path15, _path16, _path17, _path18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1830_40724",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 6,
    width: 15,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4351 6.10367V6.48909C16.4351 9.0572 16.4351 8.19305 16.4351 10.7612C16.4351 11.8566 19.9404 13.9419 19.9404 13.9419L23.3686 15.8893C23.3686 15.8893 30.1682 11.5239 30.1682 10.3717C30.1682 7.84414 30.1682 9.09372 30.1682 6.56617V6.09961H16.4351V6.10367Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1830_40724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1723 6.104H16.4351V15.8896H30.1723V6.104Z",
    fill: "url(#paint0_linear_1830_40724)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.223 2.18464C27.8073 2.18464 28.3428 2.1319 28.8621 2.19682C29.6492 2.29418 30.0833 2.76075 30.1563 3.54376C30.2009 4.0306 30.1644 4.52151 30.1644 5.04081H16.4597C16.4597 4.50122 16.4069 3.96569 16.4718 3.44639C16.5814 2.59846 17.1494 2.16842 18.0865 2.14407C18.4923 2.1319 18.902 2.14407 19.3807 2.14407C19.3807 1.81545 19.3645 1.51929 19.3807 1.22718C19.4375 0.427939 19.9609 0.0344041 20.6709 0.245371C21.0644 0.363026 21.2916 0.695704 21.32 1.23124C21.3322 1.51523 21.32 1.79922 21.32 2.11162H25.2391C25.2756 1.68157 25.2756 1.25558 25.3568 0.849872C25.446 0.407653 25.868 0.148002 26.3102 0.180458C26.7524 0.212915 27.0932 0.500966 27.1662 0.926957C27.2028 1.14198 27.2109 1.36106 27.223 1.58014C27.2311 1.74242 27.223 1.90471 27.223 2.18464Z",
    fill: "#EE777B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.31 4.03037C25.6325 4.03037 25.0848 3.66523 24.9793 3.13781C24.9184 2.83759 24.9022 2.53331 24.8819 2.23715C24.8738 2.10732 24.8657 1.97344 24.8535 1.83956L25.2633 1.80304C25.2755 1.94098 25.2836 2.07487 25.2917 2.21281C25.3079 2.50897 25.3241 2.78891 25.3809 3.05667C25.4499 3.39747 25.8516 3.62872 26.3425 3.6206C26.8455 3.61249 27.1295 3.28387 27.1782 2.97959C27.2066 2.80108 27.2188 2.61851 27.2269 2.42377V2.34263C27.235 2.23715 27.235 2.13572 27.235 1.99778V1.74219H27.6448V1.99373C27.6448 2.13978 27.6448 2.25338 27.6448 2.36697V2.44812C27.6326 2.64691 27.6204 2.84976 27.588 3.05262C27.4906 3.61655 26.9835 4.02225 26.3546 4.03442C26.3425 4.03442 26.3303 4.03442 26.3181 4.03442L26.31 4.03037Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3989 4.0185C19.7213 4.0185 19.1736 3.65336 19.0682 3.12595C19.0073 2.82572 18.9911 2.52144 18.9708 2.22528C18.9627 2.09545 18.9546 1.96157 18.9424 1.82769L19.3521 1.79117C19.3643 1.92911 19.3724 2.063 19.3805 2.20094C19.3968 2.4971 19.413 2.77704 19.4698 3.0448C19.5388 3.38965 19.9404 3.62091 20.4313 3.60874C20.9344 3.60062 21.2184 3.272 21.2671 2.97178C21.2955 2.79327 21.3076 2.6107 21.3158 2.41596V2.33482C21.3239 2.22934 21.3239 2.12791 21.3239 1.98997V1.73438H21.7336V1.98591C21.7336 2.13197 21.7336 2.24556 21.7336 2.35916V2.4403C21.7215 2.6391 21.7093 2.84195 21.6768 3.0448C21.5795 3.60874 21.0723 4.01038 20.4435 4.02661C20.4313 4.02661 20.4192 4.02661 20.4029 4.02661L20.3989 4.0185Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6628 12.9478H22.0825V14.7045H24.6628V12.9478Z",
    fill: "#FFFCE4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9304 12.9478H18.3501V14.7045H20.9304V12.9478Z",
    fill: "#FFFCE4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3952 10.3394H25.8149V12.0961H28.3952V10.3394Z",
    fill: "#FFFCE4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6628 10.3394H22.0825V12.0961H24.6628V10.3394Z",
    fill: "#FFFCE4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9304 10.3394H18.3501V12.0961H20.9304V10.3394Z",
    fill: "#FFFCE4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3952 7.72656H25.8149V9.48327H28.3952V7.72656Z",
    fill: "#FFFCE4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6628 7.72656H22.0825V9.48327H24.6628V7.72656Z",
    fill: "#FFFCE4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9304 7.72656H18.3501V9.48327H20.9304V7.72656Z",
    fill: "#FFFCE4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1830_40724",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 7,
    width: 22,
    height: 16
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1925 10.6356L23.3685 15.8895L12.6904 8.83429L12.3901 22.7054L33.6451 22.8555L33.9493 7.62935L30.1763 7.1709L30.1925 10.6356Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1830_40724)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1830_40724",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 7,
    width: 22,
    height: 16
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 7.1709H12.3901V22.8555H33.9493V7.1709Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1830_40724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 7.1709H12.3901V7.46706H33.9493V7.1709Z",
    fill: "#95D5F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 7.46729H12.3901V7.76345H33.9493V7.46729Z",
    fill: "#95D4F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 7.76318H12.3901V8.05935H33.9493V7.76318Z",
    fill: "#95D4F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 8.05957H12.3901V8.35574H33.9493V8.05957Z",
    fill: "#95D4F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 8.35547H12.3901V8.65163H33.9493V8.35547Z",
    fill: "#95D4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 8.65186H12.3901V8.94802H33.9493V8.65186Z",
    fill: "#95D4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 8.94775H12.3901V9.24392H33.9493V8.94775Z",
    fill: "#95D4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 9.23975H12.3901V9.53591H33.9493V9.23975Z",
    fill: "#94D4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 9.53613H12.3901V9.8323H33.9493V9.53613Z",
    fill: "#94D4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 9.83252H12.3901V10.1287H33.9493V9.83252Z",
    fill: "#94D4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 10.1284H12.3901V10.4246H33.9493V10.1284Z",
    fill: "#93D4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 10.4248H12.3901V10.721H33.9493V10.4248Z",
    fill: "#93D4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 10.7207H12.3901V11.0169H33.9493V10.7207Z",
    fill: "#93D3F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 11.0171H12.3901V11.3133H33.9493V11.0171Z",
    fill: "#92D3F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 11.313H12.3901V11.6092H33.9493V11.313Z",
    fill: "#91D3F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 11.6094H12.3901V11.9055H33.9493V11.6094Z",
    fill: "#91D3F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 11.9053H12.3901V12.2014H33.9493V11.9053Z",
    fill: "#90D2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 12.2017H12.3901V12.4978H33.9493V12.2017Z",
    fill: "#8FD2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 12.498H12.3901V12.7942H33.9493V12.498Z",
    fill: "#8FD2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 12.7939H12.3901V13.0901H33.9493V12.7939Z",
    fill: "#8ED1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 13.0903H12.3901V13.3865H33.9493V13.0903Z",
    fill: "#8DD1EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 13.3862H12.3901V13.6824H33.9493V13.3862Z",
    fill: "#8CD0EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 13.6826H12.3901V13.9788H33.9493V13.6826Z",
    fill: "#8BD0EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 13.9785H12.3901V14.2747H33.9493V13.9785Z",
    fill: "#8AD0EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 14.2749H12.3901V14.5711H33.9493V14.2749Z",
    fill: "#89CFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 14.5669H12.3901V14.8631H33.9493V14.5669Z",
    fill: "#87CFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 14.8633H12.3901V15.1594H33.9493V14.8633Z",
    fill: "#86CEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 15.1592H12.3901V15.4553H33.9493V15.1592Z",
    fill: "#85CDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 15.4556H12.3901V15.7517H33.9493V15.4556Z",
    fill: "#83CDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 15.7515H12.3901V16.0476H33.9493V15.7515Z",
    fill: "#82CCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 16.0479H12.3901V16.344H33.9493V16.0479Z",
    fill: "#80CCEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 16.3438H12.3901V16.6399H33.9493V16.3438Z",
    fill: "#7FCBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 16.6401H12.3901V16.9363H33.9493V16.6401Z",
    fill: "#7DCAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 16.936H12.3901V17.2322H33.9493V16.936Z",
    fill: "#7BC9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 17.2324H12.3901V17.5286H33.9493V17.2324Z",
    fill: "#79C9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 17.5283H12.3901V17.8245H33.9493V17.5283Z",
    fill: "#77C8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 17.8247H12.3901V18.1209H33.9493V17.8247Z",
    fill: "#75C7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 18.1211H12.3901V18.4173H33.9493V18.1211Z",
    fill: "#73C6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 18.417H12.3901V18.7132H33.9493V18.417Z",
    fill: "#71C5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 18.7134H12.3901V19.0095H33.9493V18.7134Z",
    fill: "#6EC4E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 19.0093H12.3901V19.3054H33.9493V19.0093Z",
    fill: "#6BC3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 19.3057H12.3901V19.6018H33.9493V19.3057Z",
    fill: "#69C2E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 19.6016H12.3901V19.8977H33.9493V19.6016Z",
    fill: "#66C1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 19.8936H12.3901V20.1897H33.9493V19.8936Z",
    fill: "#63C0E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 20.1899H12.3901V20.4861H33.9493V20.1899Z",
    fill: "#60BFE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 20.4863H12.3901V20.7825H33.9493V20.4863Z",
    fill: "#5DBEE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 20.7822H12.3901V21.0784H33.9493V20.7822Z",
    fill: "#59BDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 21.0786H12.3901V21.3748H33.9493V21.0786Z",
    fill: "#56BCE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 21.3745H12.3901V21.6707H33.9493V21.3745Z",
    fill: "#52BBE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 21.6709H12.3901V21.9671H33.9493V21.6709Z",
    fill: "#4EBAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 21.9668H12.3901V22.263H33.9493V21.9668Z",
    fill: "#49B9E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 22.2632H12.3901V22.5593H33.9493V22.2632Z",
    fill: "#45B7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9493 22.5591H12.3901V22.8552H33.9493V22.5591Z",
    fill: "#40B6E0"
  })))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07354 15.1431H0.705928C0.31645 15.1431 0 15.4595 0 15.849C0 16.2385 0.31645 16.5549 0.705928 16.5549H8.07354C8.46302 16.5549 8.77947 16.2385 8.77947 15.849C8.77947 15.4595 8.46302 15.1431 8.07354 15.1431Z",
    fill: "#9AD7F3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72245 12.5707C8.72245 12.1812 8.406 11.8647 8.01653 11.8647H3.61462C3.22514 11.8647 2.90869 12.1812 2.90869 12.5707C2.90869 12.9602 3.22514 13.2766 3.61462 13.2766H8.01653C8.406 13.2766 8.72245 12.9602 8.72245 12.5707Z",
    fill: "#9AD7F3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01654 18.3481H5.66345C5.27397 18.3481 4.95752 18.6646 4.95752 19.0541C4.95752 19.4435 5.27397 19.76 5.66345 19.76H8.01654C8.40602 19.76 8.72247 19.4435 8.72247 19.0541C8.72247 18.6646 8.40602 18.3481 8.01654 18.3481Z",
    fill: "#9AD7F3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9696 6.95152L30.1843 6.90283V8.27412L33.2718 8.31469V22.0519H13.027V9.60077L22.906 16.3558C23.1535 16.5221 23.478 16.514 23.7133 16.3314L30.5495 11.037C30.8497 10.8057 30.9024 10.3716 30.6712 10.0754C30.5495 9.92128 30.375 9.83203 30.1924 9.8158H30.1843L23.2549 15.0535L16.3214 10.1931L12.7309 7.73859C12.5199 7.59659 12.2481 7.58036 12.0209 7.69802C11.7978 7.81567 11.6558 8.05098 11.6558 8.30657V22.7456C11.6558 22.9241 11.7288 23.1027 11.8586 23.2325C11.9844 23.3623 12.1629 23.4313 12.3455 23.4313H33.9655C34.1481 23.4313 34.3225 23.3583 34.4524 23.2325C34.5822 23.1067 34.6552 22.9282 34.6552 22.7456V7.63716C34.6552 7.26391 34.3509 6.95557 33.9777 6.95152",
    fill: "#133758"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1830_40724",
    x1: 23.632,
    y1: 16.32,
    x2: 23.632,
    y2: 6.53438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8BB47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD85"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSquare);
export default __webpack_public_path__ + "static/media/logo_square.66431496fa026b545218cbdef12a9087.svg";
export { ForwardRef as ReactComponent };